import { render, staticRenderFns } from "./ComingSoonPopup.vue?vue&type=template&id=37759977"
import script from "./ComingSoonPopup.vue?vue&type=script&lang=ts"
export * from "./ComingSoonPopup.vue?vue&type=script&lang=ts"
import style0 from "./ComingSoonPopup.vue?vue&type=style&index=0&id=37759977&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports